var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductionOrderEmbeddable',{on:{"mounted":_vm.onMountedDefault},scopedSlots:_vm._u([{key:"item(typeNonConformance)",fn:function(ref){
var item = ref.item;
return [(item.materialId === 17)?_c('span',[_vm._v(_vm._s(item.typeNonConformance || '-'))]):_c('span',[_vm._v(_vm._s(item.typeRestriction || '-'))])]}}]),model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})}
var staticRenderFns = []

export { render, staticRenderFns }